import {FETCH_UPDATES} from './actions';


const initialState = {
  content: {},
  loading: false,
  lastCheck: 0,
  connected: true
};


export default function (state = initialState, action) {
  let update = (before, options) => Object.assign({}, before, options);
  switch (action.type) {
    case FETCH_UPDATES.do:
      return update(state, {loading: true});
    case FETCH_UPDATES.success:
      return update(state, {
        loading: false,
        content: action.payload,
        lastCheck: Date.now(),
        connected: true
      });
    case FETCH_UPDATES.failure:
      return update(state, {
        loading: false,
        connected: false
      });
    default:
      return state;
  }
}




// WEBPACK FOOTER //
// ./src/redux/updates/reducer.js